import { Hidden } from '@material-ui/core';
import React from 'react';
import { buttonStyles } from '../../../../global/constants/theme/styles/components/buttonstyles';
import { ListItem } from '../../../../search/search-model';
import { SearchProps } from '../../models/arc-epi-props';
import { CoveredPeople } from './participants-models';



interface ParticipantProps {
	item: ListItem;
	onSetParticipants: () => void;
	annualEnrollmentAction: () => void;
	settings: SearchProps;
	annualEnrollmentDisabled: boolean;
}

const defaultKey = 'default';
const view = 'View';
export const ParticipantView = (props: ParticipantProps) => {

	const casted = props.item as CoveredPeople;
	const classes = buttonStyles();

	const getActionText = (status: string) => {
		if (!status) {
			return props?.settings?.annualEnrollmentActionTextMapping?.filter(a => a.key === defaultKey)[0]?.value || view;
		}

		return props?.settings?.annualEnrollmentActionTextMapping?.filter(a => a.key === casted?.oe_status)[0]?.value || view;

	};

	const getStatusText = (status: string) => {
		return status ?? props?.settings?.nullEmptyAnnualEnrollmentStatusText;
	};

	return (
		<div className='sort-table-row'>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{props.settings?.participantClientNumberLabel}</p>
				</Hidden>
				<button type='button' className={classes.linkButton} onClick={props.onSetParticipants}>{casted?.masked_client_number}</button>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{props.settings?.participantNameLabel} </p>
				</Hidden>
				<div className='sort-table-row-cell-name'>
					{
						/*
						casted?.clergy &&
						<svg className='clergy-icon' aria-hidden='true' focusable='false'>
							<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#clergy-icon' />
						</svg>
						*/
					}
					<div className='sort-table-row-cell-name-text'>{casted?.full_name}</div>
				</div>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{props.settings?.participantCityLabel} </p>
				</Hidden>
				{casted?.mailing_address_city}
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{props.settings?.participantDependentLabel} </p>
				</Hidden>
				{casted?.dependent_count}
			</div>
			{
				!props.annualEnrollmentDisabled &&
				<div className='sort-table-row-cell'>
					<Hidden smUp>
						<p className='input-label'>{props.settings?.annualEnrollmentStatusLabel}</p>
					</Hidden>
					{getStatusText(casted?.oe_status)}
				</div>
			}
			{
				!props.annualEnrollmentDisabled &&
				<div className='sort-table-row-cell'>
					<Hidden smUp>
						<p className='input-label'>{props.settings?.annualEnrollmentActionLabel}</p>
					</Hidden>
					{
						casted?.ae_available &&
						<button type='button' className={classes.linkButton} onClick={props.annualEnrollmentAction}>{getActionText(casted?.oe_status)}</button>
					}
				</div>
			}
		</div>
	);

};